import styled from 'styled-components';

const label = styled.label`
  font-family: parisineclair-regular, Arial, Helvetica, sans-serif;
  font-size: 1rem;
  color: ${(props) => props.theme.colors.lightGray};
  font-weight: bold;
`;

const span = styled.span`
  font-family: parisineclair-regular, Arial, Helvetica, sans-serif;
  font-size: ${(props) => props.theme.fontSize.medium};
  color: ${(props) => props.theme.colors.white};
`;

const description = styled.h1`
  font-size: 1.25rem;
`;
const types = styled.p`
  font-size: 1.15rem;
  justify-items: center;
`;

const Text = {
  Label: label,
  Span: span,
  Description: description,
  Types: types,
};

export default Text;
